import { Component } from 'react';
import { Link } from 'react-router';

import Title from '../modules/Title';

export default class CommonComponents extends Component {
  render() {
    return (
      <section className="services">
        <Title header="h1" title="事業と活動" />
        <div className="inner">
          <ul className="services__tab">
            <li><Link to="/services/nursing-insurance" activeClassName="active"><span>介護保険</span></Link></li>
            <li><Link to="/services/volunteering" activeClassName="active"><span>有償ボランティア</span></Link></li>
            <li><Link to="/services/disability-supports" activeClassName="active"><span>障害事業</span></Link></li>
          </ul>
          <div className="services__panel">
            <div className="inner">
              {this.props.children}
            </div>
          </div>
        </div>
      </section>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Services/CommonComponents.js
 **/